export default {
  Level: {
    Employee: {
      label: '员工',
      value: "3",
    },
    Admin: {
      label: '管理员',
      value: "1",
    },
    Approver: {
      label: '审批员',
      value: "2",
    },
  },
};
